import {
  BroadcastsManagerGuard,
  MAMEditorGuard,
} from "../../guards/permission.guard";
import { Routes } from "@angular/router";
import { SchedulerComponent } from "../scheduler/scheduler.component";
import { BroadcastEditorComponent } from "./broadcast-editor/broadcast-editor.component";

export const BroadcastsRoutes: Routes = [
  {
    path: "broadcasts",
    component: SchedulerComponent,
    canActivate: [BroadcastsManagerGuard],
    children: [
      { path: "edit/:id", component: BroadcastEditorComponent },
      { path: "live/:id", component: BroadcastEditorComponent },
      { path: "**", redirectTo: "/scheduler/calendar" },
    ],
  },
];
